import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import IconButton from '@material-ui/core/IconButton';
//import Typography from '@material-ui/core/Typography';
import HelpIcon from '@material-ui/icons/Help';
import Popover from '@material-ui/core/Popover';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  popover: {
    padding: '20px',
    maxWidth: '350px',
  },
  title: {
    fontWeight: 'bold',
  },
  inlineEl: {
    display: "inline-block"
  },
  bodyText: {
    fontSize: "1.2rem"
  },
  boldedText: {
    fontWeight: "bold"
  },
  listStyle: {
    listStyleType: "disc !important",    
    marginLeft: "20px"
  },
  listParentStyle: {
    listStyleType: "disc !important",
    paddingLeft: "20px"
  }
};

const INITIAL_STATE = {
  anchorEl: null,
};

class GameHelp extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  handleClick = (event) => {
    this.setState({
      ...this.state,
      anchorEl: event.currentTarget,
    });
  };

  handleClose = () => {
    this.setState({
      ...this.state,
      anchorEl: null,
    });
  };

  render() {
    const { classes } = this.props;
    const open = Boolean(this.state.anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
      <span className={classes.inlineEl}>
        <IconButton aria-label='Help' onClick={this.handleClick}>
          <HelpIcon />
        </IconButton>
        <Popover
          id={id}
          open={open}
          anchorEl={this.state.anchorEl}
          onClose={this.handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <div className={classes.popover}>
            <div className={`${classes.bodyText} ${classes.boldedText}`}>Goal:</div>
            <ul className={`${classes.bodyText}  ${classes.listParentStyle}`}>
              <li className={classes.listStyle}>Create new understanding and empathy - employee and manager view</li>
            </ul>
           
            <div className={`${classes.bodyText} ${classes.boldedText}`}>Why?</div>
            <ul className={`${classes.bodyText}  ${classes.listParentStyle}`}>
              <li className={classes.listStyle}>Remove counterproductive viewpoints</li>
              <li className={classes.listStyle}>Build trust and collaboration</li>
              <li className={classes.listStyle}>Ensure success</li>
            </ul>

            <div className={`${classes.bodyText} ${classes.boldedText}`}>Activity:</div>
            <ul className={`${classes.bodyText}  ${classes.listParentStyle}`}>
              <li className={classes.listStyle}>Review the scenario – employee and manager view</li>
              <li className={classes.listStyle}>Record your learnings from each scenario to achieve the “why”</li>
            </ul>
          </div>
        </Popover>
      </span>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default compose(connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(GameHelp);
